<div class="partners-capital-settings-container">
  <!-- Header -->
  <div class="partners-capital-settings-container-header">
    <div class="partners-capital-settings-container-header-section">

      <p class="no-marg">How many partners<span style="color: #f44336;"> *</span></p>
      <span>
        <mat-form-field class="select-form-field">
          <input #inputPartnersCount [(ngModel)]="selectedCount"
                 (change)="updatePartnerCapitalSettings(selectedCount,'count')" matInput value="selectedCount" autocomplete="off" required>
        </mat-form-field>
      </span>
      <span>
        <mat-form-field class="form-field-dropdown">
          <mat-label>Allocation Type</mat-label>
          <mat-select matNativeControl [(value)]="selectedAllocationType"
                      (selectionChange)="updatePartnerCapitalSettings($event.value,'alloacation')" required [disabled]="defaultCount === 0">
            <mat-option value="1">Percentage %</mat-option>
            <mat-option value="0">Units</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
  </div>
  <!-- Body Content -->
  <div class="partners-capital-settings-container-body">
    <!-- Action Items -->
    <div class="partners-capital-settings-container-body-buttons">
      <div class="partners-capital-settings-container-body-buttons-left">
        <button mat-flat-button color="primary" (click)="openDialog()" [disabled]="!isEnableGroupButton">
          Combine
          Partners
        </button>
      </div>
    </div>
    <!-- Grid -->
    <div class="partners-capital-settings-container-body-grid">
      <table mat-table [dataSource]="partnerCapitalsGridData" class="settings-grid" multiTemplateDataRows>

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row; let c = index">
            <ng-container *ngIf="row.groupname else partnerChecked">
              <mat-checkbox (click)="$event.stopPropagation();" [(ngModel)]="row.isChecked" class="custom-checkbox"
                            (change)="isSelected()" [disabled]="row.isChecked === false && groupSelected">
              </mat-checkbox>
            </ng-container>
            <ng-template #partnerChecked>
              <mat-checkbox (click)="$event.stopPropagation();" [(ngModel)]="row.checked" class="custom-checkbox"
                            (change)="isSelected()" [disabled]="row.isChecked === false && groupSelected">
              </mat-checkbox>
            </ng-template>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <!-- Expanded Column for Grouping elements -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" class="custom-partner-capital-expanded" [attr.colspan]="displayedColumns.length">
            <div class="partner-capital-expanddetails"
                 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <table mat-table [dataSource]="element.childs" multiTemplateDataRows class="mat-elevation-z8 child-grid">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row; let c = index">
                    <mat-checkbox [hidden]="true" class="custom-checkbox">
                    </mat-checkbox>
                    <p class="paragraph no-marg"></p>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="partnername">
                  <th mat-header-cell *matHeaderCellDef class="col-positionname"> Name </th>
                  <td mat-cell *matCellDef="let element" class="col-positionname">
                    <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                      <div class="flex-box-vc-hl">
                        <mat-form-field>
                          <input matInput [(ngModel)]="partnerName" [value]="element.partnername" autocomplete="off">
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <ng-template #normalPartnerMode>
                      <p class="ellipse no-marg" title="{{element.partnername}}">{{element.partnername}}</p>
                    </ng-template>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Allocation Units Column -->
                <ng-container matColumnDef="allocationtypevalue">
                  <th mat-header-cell *matHeaderCellDef class="col-allocationunits">
                    <ng-container *ngIf="selectedAllocationType == 1">
                      Percentage
                    </ng-container>
                    <ng-container *ngIf="selectedAllocationType == 0">
                      Units
                    </ng-container>

                    <ng-container *ngIf="!selectedAllocationType">
                      Percentage/Units
                    </ng-container>

                  </th>
                  <!-- Percentage/Units -->
                  <td mat-cell *matCellDef="let element" class="col-allocationunits">
                    <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                      <div class="flex-box-right">
                        <mat-form-field class="allocation-editfield">
                          <input matInput class="ellipse" [(ngModel)]='allocationTypeValue'
                                 [value]="element.allocationtypevalue" autocomplete="off" (keypress)="onlyNumberKey($event)">
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <ng-template #normalPartnerMode>
                      <p class="ellipse no-marg" title="{{element.allocationtypevalue}}"> {{element.allocationtypevalue}}</p>
                    </ng-template>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="col-allocationunits-total">
                    <p class="ellipse no-marg">{{bottomTotal}}</p>
                  </td>
                </ng-container>

                <!-- Account No. Column -->
                <ng-container matColumnDef="accountno">
                  <th mat-header-cell *matHeaderCellDef class="col-accountno"> Account No. </th>
                  <td mat-cell *matCellDef="let element; let k = index" class="col-accountno">
                    <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                      <div class="flex-box-right pcs-account-col">
                        <input matInput title="{{element.accountno}}" class="ellipse" [(ngModel)]='accountNo'
                               [value]="element.accountno" readonly>
                        <button class="transparent-btn dropdown-icon" [matMenuTriggerFor]="gridaccountno">
                            <i class="fa-regular fa-angle-down"></i>
                        </button>
                      </div>
                    </ng-container>
                    <ng-template #normalPartnerMode>
                      <p class="ellipse no-marg"> {{element.accountno}}</p>
                    </ng-template>
                    <mat-menu #gridaccountno="matMenu" xPosition="before" yPosition="below" class="account-num-panel">

                      <div class="map-dropdown">
                        <div class="map-dropdown-header">
                          <input (click)="$event.stopPropagation()" matInput
                                 (keyup)="applyFilterToMapSheet($event.target.value)" placeholder="Search">
                        </div>
                        <div class="map-dropdown-body">
                          <table mat-table [dataSource]="leadsheetTblforAccount" class="issue-tbl-grid">
                            <!-- ACC.NO. Column -->
                            <ng-container matColumnDef="accountcode">
                              <th mat-header-cell *matHeaderCellDef class="accno"> ACCOUNT NO</th>
                              <td title="{{element.accountcode}}" mat-cell *matCellDef="let element" class="accno">
                                {{element.accountcode}}
                              </td>
                            </ng-container>

                            <!-- description Column -->
                            <ng-container matColumnDef="accountname">
                              <th mat-header-cell *matHeaderCellDef class="desc"> DESCRIPTION </th>
                              <td title="{{element.accountname}}" mat-cell *matCellDef="let element"
                                  class="ellipse-emailwidth desc">
                                {{element.accountname}}
                              </td>

                            </ng-container>
                            <!-- FINAL Column -->
                            <tr mat-header-row *matHeaderRowDef="trialBalanceDisplayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row let j = index; columns: trialBalanceDisplayedColumns;"
                                (click)="selectTrialAdj(row)"></tr>
                          </table>
                        </div>
                      </div>

                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Description Column -->
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef class="col-description"> Description </th>
                  <td mat-cell *matCellDef="let element" title="{{element.description}}" class="col-description">
                    <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                      <div class="flex-box-vc-hl">
                        <mat-form-field class="desc-input-field">
                          <input matInput class="desc-input-field" [(ngModel)]="description" [value]="element.description" autocomplete="off">
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <ng-template #normalPartnerMode>
                      <p class="ellipse no-marg"> {{element.description}}</p>
                    </ng-template>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef class="col-actions">
                    <div class="actions-items">actions</div>
                  </th>
                  <td mat-cell *matCellDef="let element" class="col-actions">
                    <div class="actions-items">
                      <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId;else savingMode">
                        <button title="Save" class="transparent-btn" (click)="updatePartnerCapitalSettings(element,'save')">
                            <i class="fa-regular fa-check"></i>
                        </button>
                        <button title="Cancel" class="transparent-btn" (click)="closeRow(element)">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                      </ng-container>
                      <ng-template #savingMode>
                        <button title="Edit Partner" class="transparent-btn" (click)="element.groupname? activeRow(element, 'GROUP') : activeRow(element, 'PARTNER')">
                            <i class="fa-regular fa-pen edit-icon"></i>
                        </button>
                        <button title="Delete Partner" class="transparent-btn" (click)="confirm('DELETE', element)">
                            <i class="fa-regular fa-trash-can grid-icon delete-icon"></i>
                        </button>
                      </ng-template>
                    </div>

                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="expanded-element-row"
                    [class.cust-expand-row]="expandedElement === element"></tr>
              </table>

            </div>
          </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="partnername">
          <th mat-header-cell *matHeaderCellDef class="col-positionname"> Name </th>
          <td mat-cell *matCellDef="let element" class="col-positionname">
            <ng-container *ngIf="element.groupname else partnerBlock">
              <ng-container *ngIf="isEdit && element.partnername == partnerName; else normalGroupMode">
                <div class="flex-box-vc-hl">
                  <mat-form-field>
                    <input matInput [(ngModel)]="groupName" [value]="element.groupname">
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #normalGroupMode>
                <button title="{{element.groupname}}" class="ellipse no-marg text-link" (click)="expandedElement = (expandedElement === element) ? null : element;hideAllocation(element.partnershipaccountid, expandedElement)">{{element.groupname}}</button>
              </ng-template>
            </ng-container>
            <ng-template #partnerBlock>
              <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                <div class="flex-box-vc-hl">
                  <mat-form-field>
                    <input matInput [(ngModel)]="partnerName" [value]="element.partnername">
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #normalPartnerMode>
                <p class="ellipse no-marg" title="{{element.partnername}}">{{element.partnername}}</p>
              </ng-template>
            </ng-template>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Allocation Units Column -->
        <ng-container matColumnDef="allocationtypevalue">
          <th mat-header-cell *matHeaderCellDef class="col-allocationunits">
            <ng-container *ngIf="selectedAllocationType == 1">
              Percentage
            </ng-container>
            <ng-container *ngIf="selectedAllocationType == 0">
              Units
            </ng-container>

            <ng-container *ngIf="!selectedAllocationType">
              Percentage/Units
            </ng-container>

          </th>
          <!-- Percentage/Units -->
          <td mat-cell *matCellDef="let element" class="col-allocationunits" title="{{element.allocationtypevalue}}">
            <ng-container *ngIf="element.groupname else partnerBlock">
              <p class="ellipse no-marg" *ngIf="isHide || element.partnershipaccountid !== partnerShipAccountId"> {{element.allocationtypevalue}}</p>
            </ng-container>
            <ng-template #partnerBlock>
              <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                <div class="flex-box-vc-hl flex-box-right">
                  <mat-form-field class="allocation-editfield">
                    <input matInput [(ngModel)]="allocationTypeValue" [value]="element.allocationtypevalue" autocomplete="off" (keypress)="onlyNumberKey($event)">
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-template #normalPartnerMode>
                <p class="ellipse no-marg"> {{element.allocationtypevalue}}</p>
              </ng-template>
            </ng-template>
          </td>
          <td mat-footer-cell *matFooterCellDef class="col-allocationunits-total" title="{{selectedAllocationType == 1 && bottomTotal >100 ?'Reduce the percentage for partners': ''}}">
            <p class="ellipse no-marg" [ngStyle]="{'color' : selectedAllocationType == 1 && bottomTotal >100 ?'red': '#0F0F0F'}">{{bottomTotal}}</p>
          </td>
        </ng-container>

        <!-- Account No. Column -->
        <ng-container matColumnDef="accountno">
          <th mat-header-cell *matHeaderCellDef class="col-accountno"> Account No. </th>
          <td mat-cell *matCellDef="let element; let k = index" class="col-accountno">
            <ng-container *ngIf="element.groupname else partnerBlock">
              <p class="ellipse no-marg"> {{element.accountno}}</p>
            </ng-container>
            <ng-template #partnerBlock>
              <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
                <div class="flex-box-right pcs-account-col">
                  <input matInput title="{{element.accountno}}" class="ellipse" [(ngModel)]='accountNo'
                         [value]="element.accountno" readonly>
                  <button class="transparent-btn dropdown-icon" [matMenuTriggerFor]="gridaccountno">
                    <i class="fa-regular fa-angle-down"></i>
                  </button>
                </div>
              </ng-container>
              <ng-template #normalPartnerMode>
                <p class="ellipse no-marg"> {{element.accountno}}</p>
              </ng-template>
            </ng-template>
            <mat-menu #gridaccountno="matMenu" xPosition="before" yPosition="below" class="account-num-panel">

              <div class="map-dropdown">
                <div class="map-dropdown-header">
                  <input (click)="$event.stopPropagation()" matInput
                         (keyup)="applyFilterToMapSheet($event.target.value)" placeholder="Search">
                </div>
                <div class="map-dropdown-body">
                  <table mat-table [dataSource]="leadsheetTblforAccount" class="issue-tbl-grid">
                    <!-- ACC.NO. Column -->
                    <ng-container matColumnDef="accountcode">
                      <th mat-header-cell *matHeaderCellDef class="accno"> ACCOUNT NO</th>
                      <td title="{{element.accountcode}}" mat-cell *matCellDef="let element" class="accno">
                        {{element.accountcode}}
                      </td>
                    </ng-container>

                    <!-- description Column -->
                    <ng-container matColumnDef="accountname">
                      <th mat-header-cell *matHeaderCellDef class="desc"> DESCRIPTION </th>
                      <td title="{{element.accountname}}" mat-cell *matCellDef="let element"
                          class="ellipse-emailwidth desc">
                        {{element.accountname}}
                      </td>

                    </ng-container>
                    <!-- FINAL Column -->
                    <tr mat-header-row *matHeaderRowDef="trialBalanceDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row let j = index; columns: trialBalanceDisplayedColumns;"
                        (click)="selectTrialAdj(row)"></tr>
                  </table>
                </div>
              </div>

            </mat-menu>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="col-description"> Description </th>
          <td mat-cell *matCellDef="let element" title="{{element.description}}" class="col-description">
            <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId; else normalPartnerMode">
              <div class="flex-box-vc-hl">
                <mat-form-field class="desc-input-field">
                  <input matInput class="desc-input-field" [(ngModel)]="description" [value]="element.description" autocomplete="off">
                </mat-form-field>
              </div>
            </ng-container>
            <ng-template #normalPartnerMode>
              <p class="ellipse no-marg"> {{element.description}}</p>
            </ng-template>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="col-actions">
            <div class="actions-items">actions</div>
          </th>
          <td mat-cell *matCellDef="let element" class="col-actions">
            <div class="actions-items">
              <ng-container *ngIf="isEdit && element.partnershipaccountid == partnerId;else savingMode">
                <button title="Save" class="transparent-btn" (click)="updatePartnerCapitalSettings(element,'save')">
                    <i class="fa-regular fa-check"></i>
                </button>
                <button title="Cancel" class="transparent-btn" (click)="closeRow(element)">
                    <i class="fa-regular fa-xmark"></i>
                </button>
              </ng-container>
              <ng-template #savingMode>
                <button class="transparent-btn ungroup-icon" title="ungroup" *ngIf="element.groupname" (click)="confirm('UNGROUP', element)">
                  <i class="fa-regular fa-puzzle grid-icon ungroup-icon"></i>
                </button>
                <button title="{{element.groupname? 'Edit Group' : 'Edit Partner'}}" class="transparent-btn" (click)="element.groupname? activeRow(element, 'GROUP') : activeRow(element, 'PARTNER')">
                    <i class="fa-regular fa-pen grid-icon"></i>
                </button>
                <ng-container *ngIf="element.groupname else deletePartnerBlock">
                  <button title="Delete Group" class="transparent-btn" (click)="element.oldgroupname = element.groupname;confirm('DELETEGROUP', element)">
                    <i class="fa-regular fa-trash-can grid-icon delete-icon"></i>
                  </button>
                </ng-container>
                <ng-template #deletePartnerBlock>
                  <button title="Delete Partner" class="transparent-btn" (click)="confirm('DELETE', element)">
                    <i class="fa-regular fa-trash-can grid-icon delete-icon"></i>
                  </button>
                </ng-template>
              </ng-template>
            </div>

          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"
            class="expanded-element-row"
            [class.cust-expand-row]="expandedElement === element"></tr>

        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
            class="expanded-detail-row"
            [class.cust-expanded-details-row]="expandedElement === row"></tr>

        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="footer-field"></tr>
      </table>
    </div>
  </div>
</div>
<ng-template #combineDialog>
  <div class="combinepartner-dialogbox">
    <div class="combinepartner-dialogbox-header">
      <div class="combinepartner-dialogbox-header-icon flex-box-vc-hr">
        <button mat-icon-button class="transparent-btn" [mat-dialog-close] (click)="close()">
            <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <div class="combinepartner-dialogbox-header-section flex-box">
        <h4 class="no-marg">combine partners</h4>
      </div>
    </div>
    <div class="combinepartner-dialogbox-body">
      <div class="combinepartner-dialogbox-body-content">
        <p class="no-marg">{{subHeading}}</p>
        <mat-form-field class="form-field">
          <input matInput placeholder="" [(ngModel)]="groupName" [ngModelOptions]="{standalone: true}" autofocus
                 autocomplete="off" [readonly]="readonlyGroupName !== null" required>
        </mat-form-field>
      </div>
      <div class="combinepartner-dialogbox-body-createbutton flex-box">
        <button type="button" [mat-dialog-close] mat-flat-button class="flat-btn primary-border" color="primary"
                (click)="groupingPartners()" [disabled]="!groupName">
          {{buttonHeading}}
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #deletedDialog>
  <div class="pd-dialog-delete">
    <div class="dialogboxheader">
      <div class="flex-box header-title elem-p">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
          {{deleteHeading}}
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close] (click)="changeProcessType()">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">{{confirmMessage}}</p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary" [mat-dialog-close]>No</button>
        <ng-container *ngIf="!toggleOkButton else deleteUngroupBlock">
          <button mat-flat-button class="float-right ok-button" color="primary" [mat-dialog-close]
                  (click)="updatePartnerCapitalSettings(row,'delete')">
            yes
          </button>
        </ng-container>
        <ng-template #deleteUngroupBlock>
          <button mat-flat-button class="float-right ok-button" color="primary" [mat-dialog-close]
                  (click)="unGroupingPartners(row)">
            yes
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
